<template>
  <div class="parkCarBox" @click="clickAll" v-if="rawData || errorMsg">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/parkCarIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">停车支付</div>
        </div>
        <div v-if="rawData" class="infoBox" :class="{ isExpire: isExpire }">
          <div class="infoList">
            <div class="infoItem">
              <div class="label">停车场</div>
              <div class="value">{{ rawData.parkName }}</div>
            </div>
            <div class="infoItem">
              <div class="label">车牌号</div>
              <div class="value">{{ rawData.plateNumber }}</div>
            </div>
            <div class="infoItem">
              <div class="label">入场时间</div>
              <div class="value">{{ rawData.inTime }}</div>
            </div>
            <div class="infoItem">
              <div class="label">停车时长</div>
              <div class="value">{{ formatDuration(rawData.parkTime) }}</div>
            </div>
            <div class="infoItem">
              <div class="label">订单金额</div>
              <div class="value">{{ rawData.totalAmount }}元</div>
            </div>
          </div>
          <div class="submitBtn" @click="clickJumpToH5">去支付</div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <!-- 查看更多 -->
        <div
          class="bottomBar"
          :class="{ isExpire: isExpire }"
          v-if="errorMsg != ''"
          @click="clickJumpToH5"
        >
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = {
  cxnt: {
    test: "https://h5-ntgj.test.brightcns.cn/parking/",
    prod: "https://h5-maas.speedits.com/parking/",
  },
};
const env = process.env.VUE_APP_ENV;
export default {
  props: ["businessContent"],
  data: function () {
    return {
      isExpire: false,
      timer: null,
      type: null,
      rawData: null,
      bizReq: null,
      errorMsg: "",
    };
  },
  mounted: function () {
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      this.channel = this.businessContent.channel;
      this.bizReq = JSON.parse(this.businessContent.bizReq);
      console.log(this.rawData);
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }
    this.checkIsExpire(this.businessContent);
  },
  methods: {
    // 日期转换
    formatDuration: function (minutes) {
      const MINUTES_IN_HOUR = 60;
      const MINUTES_IN_DAY = 1440;

      const days = Math.floor(minutes / MINUTES_IN_DAY);
      const hours = Math.floor((minutes % MINUTES_IN_DAY) / MINUTES_IN_HOUR);
      const mins = minutes % MINUTES_IN_HOUR;

      if (days > 0) {
        return `${days}天${hours}小时${mins}分钟`;
      } else if (hours > 0) {
        return `${hours}小时${mins}分钟`;
      } else {
        return `${mins}分钟`;
      }
    },
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpToH5();
        }, 1000);
      }
    },
    // 点击跳到h5
    clickJumpToH5: function () {
      if (this.isExpire) {
        return;
      }
      if (this.rawData && this.rawData.plateNumber) {
        this.jumpToH5(this.rawData.plateNumber);
      } else {
        this.jumpToH5();
      }
    },
    // 跳到停车页面
    jumpToH5: function (plateNumber) {
      let url = config[this.businessContent.channel][env];
      if (plateNumber) {
        url =
          url +
          `#/AiPage?sessionId=${window.localStorage.getItem(
            "sessionId"
          )}&plateNumber=${plateNumber}`;
      } else {
        url =
          url +
          `#/AiPage?sessionId=${window.localStorage.getItem("sessionId")}`;
      }
      window.location.href = url;
    },
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./parkCarBox.scss";
</style>
